import { env } from '@/src/config/env'

export const defaultBaseUrl = env.EXPO_PUBLIC_APP_BASE_URL || 'https://preprod.hozana.org/api'
